import React from 'react';
import PropTypes from 'prop-types';

class Slider extends React.Component {
  constructor(props) {
    super(props)

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchDrag = this.handleTouchDrag.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
  }
  state = {
    dragging : false,
    start : { x: 0, y: 0},
    change : { x: 0, y: 0},
    yChange : 0,
    xChange : 0,
    percent : 0,
  }
  draggingTimer = null

  static propTypes = {
    onChange : PropTypes.func.isRequired,
    percent : PropTypes.number,
    height : PropTypes.string,
  }
  componentDidMount() {
    if(this.props.percent) {
      this.setState({percent : this.props.percent});
    }
  }
  handleMouseDown(event) {
    this.setState({start : {x : event.clientX, y: event.clientY}, dragging : true});
  }
  handleMouseMove({clientX, clientY}) {
    this.handleDrag(clientX, clientY)
  }
  handleMouseUp(event) {
    this.setState({dragging : false});
  }
  handleTouchStart(event) {
    const {clientX, clientY} = event.touches[0];
    this.setState({start : {x : clientX, y: clientY}, dragging : true});
  }
  handleTouchDrag(event) {
    const {clientX, clientY} = event.touches[0];
    this.handleDrag(clientX, clientY);
  }
  handleTouchEnd(event) {
    this.setState({dragging : false});
    $('.ui-slider-handle')[0].blur()
  }
  handleDrag(x, y) {
    let _self = this;
    // console.log('mousemove', event.clientX, event.clientY, event.pageX, event.pageY, event.screenX, event.screenY)
    if(this.state.dragging) {
      const {start} = this.state;
      let current = {x, y};
      let change = 100 * ((start.y - current.y) / $(this.refs.container).height()) ;

      let new_percent = this.state.percent + change;
      if(new_percent >= 0) {
        if(this.draggingTimer) {
          clearTimeout(this.draggingTimer)
          this.draggingTimer = setTimeout(function (){
            _self.props.onChange(new_percent);
            _self.setState({dragging : false })

          }, 500);
        }
        this.props.onChange(new_percent)
        this.setState({ percent : new_percent <= 100 ? new_percent : 100, start : current })
      }
    }
  }

  render() {
    return (
      <div
        onMouseMove={this.handleDrag}
        ref='container'
        className="m-lg slider-warning ui-slider ui-corner-all ui-slider-vertical ui-widget ui-widget-content"
        style={{height: `${'156px'}`}}
        >
        <div
          onMouseMove={this.handleDrag}
          ref='range'
          className="ui-slider-range ui-corner-all ui-widget-header ui-slider-range-min"
          style={{height : `${this.state.percent}%`}}
        />
        <span
          ref='slider'
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handleMouseUp}
          onTouchStart={this.handleTouchStart}
          onTouchMove={this.handleTouchDrag}
          onTouchEnd={this.handleTouchEnd}
          tabIndex="0"
          className="ui-slider-handle ui-corner-all ui-state-default"
          style={{bottom : `${this.state.percent}%`}}
        />
      </div>
    )
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/browser/components/ui/slider.js